/**
 * DaVita Video Player - Global Script
 */
document.addEventListener('DOMContentLoaded', function () {
	function initVideoPlayers() {
		const playButtons = document.querySelectorAll('.dv-video-player__play-button');

		playButtons.forEach((button) => {
			button.addEventListener('click', function () {
				const videoContainer = this.closest('.dv-video-player__container');
				const video = videoContainer.querySelector('.dv-video-player__video');
				// once play is clicked, we show the video controls
				video.controls = 'controls';

				if (video.paused) {
					video.play();
					this.classList.add('dv-video-player__play-button--hidden');
				} else {
					video.pause();
					this.classList.remove('dv-video-player__play-button--hidden');
				}
			});
		});

		// Show play button when video ends
		const videos = document.querySelectorAll('.dv-video-player__video');
		videos.forEach((video) => {
			video.addEventListener('ended', function () {
				const playButton = this.closest('.dv-video-player__container').querySelector(
					'.dv-video-player__play-button',
				);
				playButton.classList.remove('dv-video-player__play-button--hidden');
			});

			// Hide play button when video starts playing
			video.addEventListener('play', function () {
				const playButton = this.closest('.dv-video-player__container').querySelector(
					'.dv-video-player__play-button',
				);
				playButton.classList.add('dv-video-player__play-button--hidden');
			});

			// Show play button when video is paused
			video.addEventListener('pause', function () {
				const playButton = this.closest('.dv-video-player__container').querySelector(
					'.dv-video-player__play-button',
				);
				playButton.classList.remove('dv-video-player__play-button--hidden');
			});
		});
	}

	initVideoPlayers();

	// Re-initialize video players when content is updated.
	document.addEventListener('contentUpdated', initVideoPlayers);
});
